// 事项列表相关路由
export default [
  {
    path: '/service',
    name: 'service',
    component: () => import('@/jaas/service/ServiceView.vue'),
    meta: {
      title: '帮代办专区-在线预约-事项列表'
    }
  },
  {
    path: '/upload-file-by-mobile',
    name: 'upload-file-by-mobile',
    component: () => import('@/jaas/service/UploadFileByMobile.vue'),
    meta: {
      title: '帮代办专区-在线预约-手机上传文件'
    }
  },
  {
    path: '/sign-view',
    name: 'sign-view',
    component: () => import('@/jaas/service/SignView.vue'),
    meta: {
      title: '帮代办专区-在线预约-签字授权'
    }
  }
]
